import { useTranslation } from 'react-i18next'
import { Box, IconArrowRight, Text } from '@machobear/design-system'
import { useListingActions } from '../context/listing-actions'

export const TrackPerformanceLink = () => {
  const { t } = useTranslation()
  const { goToInsights } = useListingActions()

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap="xsmall"
      onClick={goToInsights}
      cursor="pointer"
    >
      <Text size="small" weight="strong" tone="formAccent">
        {t('Track performance')}
      </Text>
      <IconArrowRight tone="formAccent" />
    </Box>
  )
}
